import React, { useState, useEffect } from "react";
import "./nav.css";
import { Menu, MenuList, MenuButton, MenuItem, IconButton } from "@chakra-ui/react";
import { RxHamburgerMenu } from "react-icons/rx";
import { Link } from "react-router-dom";

const Nav = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="navbar-logo">
        <Link to="/">
          <span className="logo-text">
            Simba Education <span className="logo-highlight">Consultants</span>
          </span>
        </Link>
      </div>

      <ul className="navbar-links">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/services">Services</Link></li>
        <li><Link to="/about">About Us</Link></li>
        <li><Link to="/contact">Contact</Link></li>
      </ul>

      <div className="navbar-cta">
        <Link to="/contact" className="appointment-btn">Get Appointment</Link>
      </div>

      <div className="menu-container">
        <Menu>
          <MenuButton
            as={IconButton}
            aria-label="Options"
            icon={<RxHamburgerMenu />}
            variant="outline"
          />
          <MenuList>
            <MenuItem><Link to="/">Home</Link></MenuItem>
            <MenuItem><Link to="/services">Services</Link></MenuItem>
            <MenuItem><Link to="/about">About Us</Link></MenuItem>
           
            <MenuItem><Link to="/contact">Contacts</Link></MenuItem>
          </MenuList>
        </Menu>
      </div>
    </nav>
  );
};

export default Nav;
